//libraries
import React, { memo, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useLocation } from 'react-router-dom';

//context
import { SubNavContext } from 'shared/components/SubNav';
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';

//constants
import { TEXTS } from 'shared/components/Header/DesktopHeaderV2/components/HeaderActions/components/Auth/constants';
import { AUTH_URI } from 'shared/constants/uri';

//styles
import { Logout, MenuItemWrapper, Greeting, Info, Notification } from './styles';
import { removeShowCartMerge } from 'shared/components/CartMerge';

//def
interface ILoggedInProps {
  userName: string;
  mobile: string;
  email: string;
  hideEmail: boolean;
  shouldVerifyMobile: boolean;
  shouldVerifyEmail: boolean;
}

function LoggedIn({
  userName,
  mobile,
  email,
  hideEmail,
  shouldVerifyMobile,
  shouldVerifyEmail,
}: ILoggedInProps) {
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const { doHide } = useContext(SubNavContext);
  const { showAuthModal } = useAuthModalWrapperContext();

  const goToMyOrder = () => {
    doHide();
    window.location.href = '/sales/order/history';
  };

  const logout = () => {
    doHide();
    removeShowCartMerge();
    window.location.href = '/customer/account/logout';
  };

  const clickHandler = (requiredURI: string) => {
    params.set(AUTH_URI.PARAM_KEY, requiredURI);
    const url = pathname + '?' + params.toString();
    doHide();

    showAuthModal(url);
  };

  return (
    <MenuItemWrapper>
      <Greeting>{TEXTS.HI_USER(userName)}</Greeting>
      {isEmpty(mobile) === false && <Info>{mobile}</Info>}
      {isEmpty(email) === false && hideEmail === false && <Info>{email}</Info>}

      {shouldVerifyMobile === true && (
        <Notification onClick={() => clickHandler(AUTH_URI.MOBILE_NUMBER_VERIFICATION)}>
          {TEXTS.VERIFY_MOBILE_LABEL}
        </Notification>
      )}

      {shouldVerifyEmail === true && (
        <Notification onClick={() => clickHandler(AUTH_URI.MERGE_ACCOUNTS)}>
          {TEXTS.VERIFY_EMAIL_LABEL}
        </Notification>
      )}

      <button onClick={goToMyOrder} className="sub-menu__menu-item border-bottom border-top">
        {TEXTS.ORDERS}
        <i className="icon icon-orders" />
      </button>

      <Logout onClick={logout}>{TEXTS.LOGOUT}</Logout>
    </MenuItemWrapper>
  );
}

export default memo(LoggedIn);
